import type {WorkflowActivationNotifications} from 'src/types/workflow';
import type {WorkflowsActivationAction} from 'src/action-creators/workflow-activation';

import {
  RECEIVE_ALL,
  ADD_RECENTLY_RESOLVED,
} from 'src/action-creators/workflow-activation';


export type WorkflowActivationState = {
  notifications: WorkflowActivationNotifications;
  recentlyResolved: string[];
};

const initialState = {
  notifications: Object.freeze({}),
  recentlyResolved: [],
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly notifications: Readonly<{}>; readonly recentlyResolved: readonly []; }' is not assignable to type 'WorkflowActivationState'.
  state: WorkflowActivationState | null | undefined = initialState,
  action: WorkflowsActivationAction,
): WorkflowActivationState => {
  switch (action.type) {
    case RECEIVE_ALL: {
      // @ts-expect-error - TS2322 - Type '{ notifications: WorkflowActivationNotifications; recentlyResolved?: string[] | undefined; }' is not assignable to type 'WorkflowActivationState'.
      return {
        ...state,
        notifications: action.payload,
      };
    }
    case ADD_RECENTLY_RESOLVED: {
      // @ts-expect-error - TS2322 - Type '{ recentlyResolved: string[]; notifications?: WorkflowActivationNotifications | undefined; }' is not assignable to type 'WorkflowActivationState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        recentlyResolved: [...state.recentlyResolved, ...action.payload],
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'WorkflowActivationState | null' is not assignable to type 'WorkflowActivationState'.
  return state;
};
